import React from 'react';
import AdminMasterLayout from '../../../layouts/gcadmin/adminMasterLayout/AdminMasterLayout';
import ManageBooksPage from '../../../subsreens/gcadmin/managebooks/ManageBooksPage';


const ManageBooks = () => {
    return(
        <AdminMasterLayout>
            <ManageBooksPage></ManageBooksPage>
        </AdminMasterLayout>
    )
}

export default ManageBooks;